module.exports = __webpack_public_path__ + "img/48600.af698966.jpg";